export default "__VITE_ASSET__VN5gPtpbL6YdXnOlYcZH5w__"